import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { Typography, Button, Box, Paper, Container, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { LanguageContext } from '../contexts/LanguageContext';
var MuscleRelaxation = function (_a) {
    var onFinish = _a.onFinish;
    var t = useContext(LanguageContext).t;
    // Parse the muscle instructions array from the translations
    var muscleInstructions = t('muscleInstructions');
    return (_jsx(Container, { maxWidth: "sm", sx: {
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            py: 2
        }, children: _jsxs(Paper, { elevation: 3, sx: {
                p: { xs: 2, sm: 4 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: 2,
                bgcolor: 'background.paper',
                width: '100%',
                minHeight: { xs: 'calc(100vh - 120px)', sm: 'auto' }
            }, children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, align: "center", children: t('muscleRelaxationTitle') }), _jsx(Typography, { variant: "body1", align: "center", paragraph: true, sx: { mt: 1, mb: 3 }, children: t('muscleRelaxationDesc') }), _jsx(Divider, { sx: { width: '100%', my: 2 } }), _jsx(List, { sx: { width: '100%' }, children: muscleInstructions.map(function (instruction, index) { return (_jsxs(React.Fragment, { children: [_jsxs(ListItem, { alignItems: "flex-start", children: [_jsx(ListItemIcon, { children: _jsx(FitnessCenterIcon, { color: "primary" }) }), _jsx(ListItemText, { primary: "".concat(index + 1, ". ").concat(instruction) })] }), index < muscleInstructions.length - 1 && (_jsx(Divider, { component: "li", variant: "inset" }))] }, index)); }) }), _jsx(Box, { sx: { mt: 4 }, children: _jsx(Button, { variant: "contained", color: "primary", size: "large", onClick: onFinish, sx: { py: 1.5, px: 4 }, children: t('finish') }) })] }) }));
};
export default MuscleRelaxation;
